import React, { useState } from "react";
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import { MeetingsConductedChartOuter } from "./styles";



const ActiveUserCharts = (props) => {
  const [duration,setDuration]= useState('monthly')
  const  data = props.data[duration] || [];
  return (
    <MeetingsConductedChartOuter>
      <ResponsiveContainer width="100%" height="80%">
        <LineChart
          width={200}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 50,
            // left: 0,
            bottom: 10,
          }}
        >
          <XAxis 
          
          dataKey="name"
            interval={'preserveStartEnd'}  // Show all data if less than 6 points
            angle={0}  // Rotate labels for better readability
            textAnchor="start" // Align rotated labels
            />
          <YAxis />
          <Tooltip />
         
          <Line
            strokeWidth={3}
            type="monotone"
            dataKey="count"
            stroke="#FF5C25"
            activeDot={{ r: 8 }}
          />
      
        </LineChart>
      </ResponsiveContainer>
    </MeetingsConductedChartOuter>
  );
};

export default ActiveUserCharts;
